import React from 'react';
import { i18n } from '../../i18n/translate.js';
import { sanitizeUrl } from '@braintree/sanitize-url';
import { tokens } from '@everfi/design-system';
import GeneralErrorImg from '../../images/general_error.svg.js';
import NotFoundImg from '../../images/not_found.svg.js';
import NoAccessImg from '../../images/no_access.svg.js';
import MaintenanceImg from '../../images/maintenance.svg.js';
import Link from '../../core/components/Link/component.js';
import { Layout } from '../../core/components/Layout/component.js';
import { Typography } from '../../core/components/Typography/component.js';
import { Image } from '../../core/components/Image/component.js';
import Button from '../../core/components/Button/component.js';
var images = {
  general_error: GeneralErrorImg,
  not_found: NotFoundImg,
  no_access: NoAccessImg,
  maintenance: MaintenanceImg
};

var ErrorPage = function ErrorPage(props) {
  var _props$type;

  var imageUrl = images[(_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : ''] || GeneralErrorImg;
  /**
   * Dom
   */

  return /*#__PURE__*/React.createElement(Layout, {
    variant: "flex",
    alignItems: 'center',
    flexDirection: 'column'
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: 'h2'
  }, " ", props.title), !!(props.errors && props.errors.length > 0) && props.errors.map(function (error, index) {
    var isValid = typeof error === 'string' || /*#__PURE__*/React.isValidElement(error);

    if (!isValid) {
      return null;
    }

    return /*#__PURE__*/React.createElement(Typography, {
      variant: 'p',
      key: "error[".concat(index, "]")
    }, error);
  }), /*#__PURE__*/React.createElement(Image, {
    path: imageUrl,
    description: i18n.t('Error'),
    width: "200"
  }), props.techContact && /*#__PURE__*/React.createElement(Layout, {
    variant: "container",
    bg: tokens.ColorsGrey100,
    padding: tokens.SpacingBaseXs,
    marginBottom: tokens.SpacingBaseXs
  }, /*#__PURE__*/React.createElement(Typography, null, i18n.t('Please email or call your technical contact if this error persists')), /*#__PURE__*/React.createElement(Layout, {
    variant: "flex",
    flexDirection: 'row',
    gap: 10
  }, /*#__PURE__*/React.createElement(Typography, null, props.techContact.technical_contact_name), /*#__PURE__*/React.createElement(Typography, null, props.techContact.technical_contact_phone), /*#__PURE__*/React.createElement(Link, {
    href: sanitizeUrl("mailto:".concat(props.techContact.technical_contact_email))
  }, props.techContact.technical_contact_email))), props.backButtonText && props.backButtonUrl && /*#__PURE__*/React.createElement(Button, {
    variant: "solid",
    href: props.backButtonUrl
  }, props.backButtonText || i18n.t('Back to Learner Dashboard')));
};

ErrorPage.displayName = "ErrorPage";
export { ErrorPage };